import e, { removeClassStyleAttrs as t, returnFirstEl as n, warnIfUnmounted as r } from "../../common/utils/index.js";
import { t as i } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { DialtoneLocalization as a } from "../../localization/index.js";
import o from "../button/button.js";
import s from "../popover/popover.js";
import { CALLBAR_BUTTON_VALID_WIDTH_SIZE as c } from "../callbar-button/callbar-button-constants.js";
import l from "../callbar-button/callbar-button.js";
import { createBlock as u, createCommentVNode as d, createElementBlock as f, createSlots as p, createVNode as m, mergeProps as h, normalizeClass as g, normalizeStyle as _, openBlock as v, renderSlot as y, resolveComponent as b, withCtx as x } from "vue";
import { DtIconChevronUp as S } from "@dialpad/dialtone-icons/vue";
//#region recipes/buttons/callbar_button_with_popover/callbar_button_with_popover.vue
var C = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeCallbarButtonWithPopover",
	components: {
		DtRecipeCallbarButton: l,
		DtPopover: s,
		DtButton: o,
		DtIconChevronUp: S
	},
	inheritAttrs: !1,
	props: {
		id: {
			type: String,
			default() {
				return e.getUniqueString();
			}
		},
		ariaLabel: {
			type: String,
			default: null,
			validator: (e) => e || (void 0).$slots.default
		},
		placement: {
			type: String,
			default: "top"
		},
		offset: {
			type: Array,
			default: () => [0, 16]
		},
		initialFocusElement: {
			type: String,
			default: "first"
		},
		showCloseButton: {
			type: Boolean,
			default: !0
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		forceShowArrow: {
			type: Boolean,
			default: !1
		},
		active: {
			type: Boolean,
			default: !1
		},
		danger: {
			type: Boolean,
			default: !1
		},
		onClick: {
			type: Function,
			default: null
		},
		buttonClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		textClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		buttonWidthSize: {
			type: String,
			default: "xl",
			validator: (e) => c.includes(e)
		},
		contentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		openPopover: {
			type: Boolean,
			default: !1
		},
		invertedTooltip: {
			type: Boolean,
			default: !1
		},
		showTooltip: {
			type: Boolean,
			default: null
		},
		tooltipText: {
			type: String,
			default: void 0
		},
		tooltipDelay: {
			type: Boolean,
			default: void 0
		}
	},
	emits: [
		"arrow-click",
		"click",
		"opened"
	],
	data() {
		return {
			open: !1,
			i18n: new a()
		};
	},
	computed: {
		showArrowButton() {
			return this.forceShowArrow || !this.disabled;
		},
		isCompactMode() {
			return this.buttonWidthSize === "sm" || this.buttonWidthSize === "md";
		},
		showPopover() {
			return !this.openPopover || this.open ? (this.syncOpenState(), !1) : this.toggleOpen();
		},
		arrowButtonLabel() {
			return this.i18n.$t("DIALTONE_CALLBAR_BUTTON_WITH_POPOVER_ARROW_BUTTON_ARIA_LABEL");
		}
	},
	mounted() {
		r(n(this.$el), this.$options.name);
	},
	methods: {
		removeClassStyleAttrs: t,
		arrowClick(e) {
			return this.$emit("arrow-click", e), this.toggleOpen();
		},
		toggleOpen() {
			return this.open = !this.open;
		},
		syncOpenState() {
			this.open = this.openPopover;
		},
		buttonClick(e) {
			this.$props.onClick ? this.$emit("click", e) : this.arrowClick(e);
		},
		onModalIsOpened(e) {
			this.open = e, this.$emit("opened", e);
		}
	}
};
function w(e, t, n, r, i, a) {
	let o = b("dt-recipe-callbar-button"), s = b("dt-icon-chevron-up"), c = b("dt-button"), l = b("dt-popover");
	return v(), f("div", {
		class: g(["d-recipe-callbar-button-with-popover", e.$attrs.class]),
		style: _(e.$attrs.style)
	}, [m(o, {
		"aria-label": n.ariaLabel,
		disabled: n.disabled,
		active: n.active,
		danger: n.danger,
		"button-class": n.buttonClass,
		"button-width-size": n.buttonWidthSize,
		"text-class": n.textClass,
		"inverted-tooltip": n.invertedTooltip,
		"show-tooltip": n.showTooltip,
		"tooltip-text": n.tooltipText,
		"tooltip-delay": n.tooltipDelay,
		class: "d-recipe-callbar-button-with-popover--main-button",
		onClick: a.buttonClick
	}, p({
		tooltip: x(() => [y(e.$slots, "tooltip")]),
		default: x(() => [y(e.$slots, "default")]),
		_: 2
	}, [e.$slots.blockStartIcon ? {
		name: "blockStartIcon",
		fn: x(() => [y(e.$slots, "blockStartIcon")]),
		key: "0"
	} : void 0, e.$slots.icon ? {
		name: "icon",
		fn: x(() => [y(e.$slots, "icon")]),
		key: "1"
	} : void 0]), 1032, [
		"aria-label",
		"disabled",
		"active",
		"danger",
		"button-class",
		"button-width-size",
		"text-class",
		"inverted-tooltip",
		"show-tooltip",
		"tooltip-text",
		"tooltip-delay",
		"onClick"
	]), a.showArrowButton ? (v(), u(l, h({
		key: 0,
		id: n.id,
		modal: !1,
		open: i.open,
		placement: n.placement,
		"initial-focus-element": n.initialFocusElement,
		"show-close-button": n.showCloseButton,
		offset: n.offset,
		padding: "none",
		class: "d-recipe-callbar-button-with-popover__popover-wrapper",
		"dialog-class": ["d-recipe-callbar-button-with-popover__popover", n.contentClass]
	}, a.removeClassStyleAttrs(e.$attrs), {
		"open-popover": a.showPopover,
		onOpened: a.onModalIsOpened
	}), {
		anchor: x(() => [m(c, {
			active: i.open,
			class: g(["d-recipe-callbar-button-with-popover__arrow", { "d-recipe-callbar-button-with-popover__arrow--large": !a.isCompactMode }]),
			circle: !0,
			importance: "clear",
			size: 400,
			"aria-label": a.arrowButtonLabel,
			title: a.arrowButtonLabel,
			width: "2rem",
			onClick: a.arrowClick
		}, {
			startIcon: x(() => [m(s, {
				class: "d-recipe-callbar-button-with-popover__arrow-icon",
				size: "200"
			})]),
			_: 1
		}, 8, [
			"active",
			"class",
			"aria-label",
			"title",
			"onClick"
		])]),
		content: x(() => [y(e.$slots, "content")]),
		headerContent: x(() => [y(e.$slots, "headerContent")]),
		footerContent: x(() => [y(e.$slots, "footerContent")]),
		_: 3
	}, 16, [
		"id",
		"open",
		"placement",
		"initial-focus-element",
		"show-close-button",
		"offset",
		"dialog-class",
		"open-popover",
		"onOpened"
	])) : d("", !0)], 6);
}
var T = /* @__PURE__ */ i(C, [["render", w]]);
//#endregion
export { T as default };

//# sourceMappingURL=callbar-button-with-popover.js.map